var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBenefitIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#FFFFFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9524 44.1904H35.0477M32 19.8095V18.2856M39.6191 22.8571L41.1429 21.3333M24.381 22.8571L22.8572 21.3333M39.6191 36.5714L41.1429 38.0952M24.381 36.5714L22.8572 38.0952M21.3334 28.9523H19.8096M44.1905 28.9523H42.6667M32 23.619C33.5472 23.618 35.0492 24.1403 36.262 25.101C37.4747 26.0616 38.327 27.4041 38.6802 28.9104C39.0335 30.4167 38.867 31.9981 38.2078 33.3978C37.5486 34.7975 36.4354 35.9331 35.0492 36.6201L35.0477 38.0952C35.0477 38.9034 34.7266 39.6786 34.155 40.2502C33.5835 40.8217 32.8083 41.1428 32 41.1428C31.1918 41.1428 30.4166 40.8217 29.8451 40.2502C29.2735 39.6786 28.9524 38.9034 28.9524 38.0952V36.6201C27.5663 35.9332 26.4532 34.7977 25.794 33.3982C25.1347 31.9986 24.9681 30.4173 25.3212 28.9111C25.6743 27.405 26.5263 26.0624 27.7388 25.1017C28.9513 24.1409 30.453 23.6184 32 23.619Z",
    stroke: "#1784FB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitIcon3);
export default __webpack_public_path__ + "static/media/benefit_icon_3.664642b7a88e13c6c89fdfb219dcd021.svg";
export { ForwardRef as ReactComponent };